import { useTranslation } from "react-i18next";
import AppConfigContext from "../../context/AppConfigContext";
import { useContext } from "react";

const FormHeader = ({ step }) => {
    const { config } = useContext(AppConfigContext)
    const { t } = useTranslation(config.theme, { keyPrefix: "header" });

    if (step !== 1) {
        return <></>
    }

    return (
        <div className="bg-primary p-4 text-white">
            <p>{t("content1")}</p>

            <ul>
                <li>{t("list1")}</li>
                <li>{t("list2")}</li>
                <li>{t("list3")}</li>
                <li>{t("list4")}</li>
            </ul>

            <p className="fw-bold mb-0">{t("content2")}</p>
        </div>
    );
}

export default FormHeader;
